
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 91.09 87.92"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"45.54","cy":"43.96","r":"38.08","fill":"#f59121"}}),_c('path',{attrs:{"d":"M45.07 68.66a24.7 24.7 0 010-49.4 5.7 5.7 0 110 11.4 13.3 13.3 0 000 26.6 5.7 5.7 0 110 11.4z","fill":"#fff"}}),_c('path',{attrs:{"d":"M46 68.66a5.7 5.7 0 010-11.4 13.3 13.3 0 000-26.6 5.7 5.7 0 010-11.4 24.7 24.7 0 010 49.4z","opacity":".33","fill":"#fff"}})])
          )
        }
      }
    